import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=7bae306c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=7bae306c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae306c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bae306c')) {
      api.createRecord('7bae306c', component.options)
    } else {
      api.reload('7bae306c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=7bae306c&scoped=true&", function () {
      api.rerender('7bae306c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Tcv8X3B3Mr0t/JS/comp/PopupBox.vue"
export default component.exports